import { completeTypes, createTypes, withPostSuccess } from 'redux-recompose';

import { CONTRACTS_NAMES, CONTRACTS_FUNCTIONS } from '#models/contracts/constants';
import * as ContractsService from '#services/ContractsService';
import ModalActions from '#redux/Modal/actions';
import { MODALS } from '#redux/Modal/constants';

import { ADMINS_TARGETS } from './constants';
import { mapAddAdmin } from './mappers';

export const actions = createTypes(
  completeTypes({
    primaryActions: ['ADD_ADMIN'],
    ignoredActions: []
  }),
  '@@ADMINS'
);

export const actionCreators = {
  addAdmin: params => ({
    type: actions.ADD_ADMIN,
    target: ADMINS_TARGETS.ADD_ADMIN,
    payload: {
      functionName: CONTRACTS_FUNCTIONS.ADD_ADMIN,
      contractName: CONTRACTS_NAMES.ADMIN,
      functionParams: mapAddAdmin(params)
    },
    service: ContractsService.execFunction,
    injections: [
      withPostSuccess(dispatch => {
        dispatch(ModalActions.closeModal(MODALS.NEW_ADMIN));
      })
    ]
  })
};

export default actionCreators;
